import { useDispatch, useSelector } from 'react-redux'
import AnimatedPage from '../components/animatedPage'
import Accordion from '../components/courseDetail/accordion'
import Banner from '../components/courseDetail/banner'
import CareerProspect from '../components/courseDetail/careerProspect'
import Contact from '../components/courseDetail/contact'
import CourseDetailVideo from '../components/courseDetail/courseDetailVideo'
import EntryRequirements from '../components/courseDetail/entryRequirements'
import MeetOurLecturers from '../components/courseDetail/meetOurLecturers'
import NextIntake from '../components/courseDetail/nextIntake'
import RelatedCourses from '../components/courseDetail/relatedCourses'
import WhatYouWillLearn from '../components/courseDetail/whatYouWillLearn'
import { useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import {
  GetCourseDetailPath,
  retrunAssets,
  returnPdf
} from '../utils/getAssets'
import { fetchCourseDetailData } from '../redux/slice/courseDetailPage'
import { DecodeHtml } from '../utils/decodeHtml'
import { fetchAllProgrammesData } from '../redux/slice/allProgrammesPage'
import { FaArrowRightLong } from 'react-icons/fa6'

const CourseDetail = () => {
  const dispatch = useDispatch()

  const { field, name } = useParams()

  // useEffect(() => {
  //   dispatch(fetchAllProgrammesData('/all-programmes'))
  // }, [])

  useEffect(() => {
    if (field && name) {
      dispatch(fetchCourseDetailData(`/all-programmes/${field}/${name}`))
    }
  }, [field, name, dispatch])
  // const name = state?.data?.name
  const state = useSelector(state => state.courseDetail)
  const courseDetail = state?.data?.properties
  const title = state?.data?.name
  const bg =
    courseDetail?.backgroundImage != null
      ? courseDetail?.backgroundImage[0]?.url
      : ''
  const courseMQA = courseDetail?.courseMQA
  const courseIntroductoryVideo =
    courseDetail?.courseIntroductoryVideo != null
      ? retrunAssets(courseDetail?.courseIntroductoryVideo[0]?.url)
      : null
  const aboutCourse = courseDetail?.aboutCourse?.markup
  const whatYouWillLearn = courseDetail?.whatYouWillLearn
  const entryRequirements = courseDetail?.entryRequirements?.markup
  const table = courseDetail?.feeTable?.items?.map(d => ({
    feeType: d?.content?.properties?.label,
    malaysian: DecodeHtml({ html: d?.content?.properties?.malaysian?.markup }),
    international: DecodeHtml({
      html: d?.content?.properties?.international?.markup
    })
  }))
  const footerNote = courseDetail?.footerNote?.markup
  const nextIntakeDate = courseDetail?.nextIntakeDate
  const courseBrochureDownload = returnPdf(courseDetail?.courseBrochureDownload)
  const unitenFeesTableDownload = returnPdf(
    courseDetail?.unitenFeesTableDownload
  )
  const scholarshipAndAidDownload = returnPdf(
    courseDetail?.unitenFeesTableInternationalDownload
  )

  const relatedCourses = courseDetail?.relatedCourse?.items?.map(d => ({
    name: d?.content?.properties?.courseName,
    link: d?.content?.properties?.coursePath
      ? '/all-programmes/' +
        d?.content?.properties?.coursePath[0]?.route?.path?.split('/')[2] +
        '/' +
        d?.content?.properties?.coursePath[0]?.route?.path?.split('/')[3]
      : null
  }))
  const accordion = courseDetail?.accordion?.items
  const careerProspect = courseDetail?.careerProspect?.markup
  const lecturer = courseDetail?.lecturer
  const exploreCollege = courseDetail?.explore !== null ? courseDetail?.explore?.items[0]?.content?.properties?.coursePath[0]?.route?.path : null
  

  return (
    <AnimatedPage>
      <Banner img={bg} />
      <div className='w-full mb-20   md:p-4 flex items-center justify-center'>
        <div className='w-full 2xl:w-11/12 p-3 md:p-4 grid grid-cols-1  lg:grid-cols-[65%_35%] gap-5'>
          <div className='w-full' id='Left'>
            <div className='flex flex-col '>
              <span className='text-3xl  2xl:text-4xl font-bold '>
                {title}
                <br />
              </span>
              <span className='  text-lg 2xl:text-base font-bold '>
                {courseMQA}
              </span>
            </div>
            <div className='pt-8 border-t  mt-16 flex flex-col items-start gap-8'>
              {courseIntroductoryVideo && (
                <CourseDetailVideo vid={courseIntroductoryVideo} />
              )}
              <section
                className='flex flex-col items-start gap-3 mt-5'
                id='about'
              >
                <h2 className='text-3xl lg:text-xl font-bold'>About Course</h2>
                <p className='text-neutral-500 text-xl 2xl:text-base text-justify w-full lg:w-5/6'>
                  <div dangerouslySetInnerHTML={{ __html: aboutCourse }} />
                </p>
              </section>
              <section
                className='flex  flex-col items-start w-full gap-3 mt-5'
                id='whatYouLearn'
              >
                <h2 className='text-3xl lg:text-xl font-bold'>
                  What You&apos;ll Learn
                </h2>
                <WhatYouWillLearn list={whatYouWillLearn} />
              </section>
              <EntryRequirements
                prereqs={entryRequirements}
                otherEqs={table}
                footerNote={footerNote}
              />
            </div>
          </div>
          <div className='flex flex-col gap-8 items-start' id='Right'>
            <NextIntake
              date={nextIntakeDate}
              brochure={courseBrochureDownload}
              feeTable={unitenFeesTableDownload}
              scholarshipAndAidDownload={scholarshipAndAidDownload}
            />
            {relatedCourses && <RelatedCourses courses={relatedCourses} />}
            {accordion && <Accordion data={accordion} />}
            <Contact />
            {careerProspect && <CareerProspect data={careerProspect} />}
           {
           exploreCollege !== null &&
           <div className='w-full md:w-5/6 lg:w-[27rem] h-fit bg-sky-900 rounded-2xl border py-8 flex flex-col p-8 gap-5'>
              <div className='text-white  text-lg font-semibold'>
                <p>Explore Our College</p>
               
              </div>
              <Link
                to={exploreCollege}
                className='flex gap-3 text-center justify-center font-bold items-center p-2 px-8 2xl:text-[16px] 2xl:leading-7 rounded bg-[#9c0000] text-white w-fit text-xs whitespace-nowrap'
              >
                College
              </Link>
            </div>}
            {lecturer && <MeetOurLecturers data={lecturer} />}
          </div>
        </div>
      </div>
    </AnimatedPage>
  )
}

export default CourseDetail
